import React from 'react';
import { Outlet } from 'react-router-dom';
import TrackingCodeList from 'page/Application/ManageTrackingCode/TrackingCodeList';
import EditTrackingCode from 'page/Application/ManageTrackingCode/EditTrackingCode';
import RegisterTrackingCode from 'page/Application/ManageTrackingCode/RegisterTrackingCode';

const ManageTrackingCode = () => {
  return <Outlet />;
};

export default ManageTrackingCode;

export { TrackingCodeList, EditTrackingCode, RegisterTrackingCode };
